import React from "react";
import * as Feather from "react-feather";
import { Scale, Calculator } from "lucide-react";

/**
 * The icon set the backoffice screens use, sized for inline use. Group icons are looked up by the
 * key stored on the task (send, scale, calc).
 */
export const I = {
	chev: p => <Feather.ChevronDown size={16} {...p} />,
	chevL: p => <Feather.ChevronLeft size={16} {...p} />,
	chevR: p => <Feather.ChevronRight size={16} {...p} />,
	mail: p => <Feather.Mail size={16} {...p} />,
	cal: p => <Feather.Calendar size={16} {...p} />,
	edit: p => <Feather.Edit2 size={16} {...p} />,
	trash: p => <Feather.Trash2 size={16} {...p} />,
	check: p => <Feather.Check size={12} strokeWidth={3} {...p} />,
	plus: p => <Feather.PlusCircle size={16} {...p} />,
	plusPlain: p => <Feather.Plus size={16} {...p} />,
	repeat: p => <Feather.Repeat size={16} {...p} />,
	refresh: p => <Feather.RefreshCw size={16} {...p} />,
	user: p => <Feather.User size={16} {...p} />,
	clock: p => <Feather.Clock size={16} {...p} />,
	card: p => <Feather.CreditCard size={16} {...p} />,
	briefcase: p => <Feather.Briefcase size={16} {...p} />,
	send: p => <Feather.Send size={16} {...p} />,
	scale: p => <Scale size={16} {...p} />,
	calc: p => <Calculator size={16} {...p} />,
	list: p => <Feather.List size={16} {...p} />,
	search: p => <Feather.Search size={16} {...p} />,
	file: p => <Feather.FileText size={16} {...p} />,
	link: p => <Feather.Link size={16} {...p} />,
	info: p => <Feather.Info size={16} {...p} />,
	bell: p => <Feather.Bell size={16} {...p} />,
	download: p => <Feather.Download size={16} {...p} />,
	alert: p => <Feather.AlertCircle size={16} {...p} />,
	x: p => <Feather.X size={16} {...p} />,
	users: p => <Feather.Users size={16} {...p} />,
	zap: p => <Feather.Zap size={16} {...p} />,
	book: p => <Feather.BookOpen size={16} {...p} />,
	grip: p => <Feather.Menu size={14} {...p} />,
};

export function groupIcon(key) {
	const Icon = I[key] || I.calc;
	return <Icon />;
}
